import React from "react";
import { distributionItems } from "../../data/distributionItems";
import { ReactComponent as Mail } from '../../icons/icons8-mail.svg';
import { ReactComponent as Telegram } from '../../icons/icons8-telegram.svg';
import { ReactComponent as Whatsapp } from '../../icons/icons8-whatsapp.svg';
import { ReactComponent as Flash } from '../../icons/flash.svg';
import { useTranslation } from 'react-i18next';

import "./Services.css";
import {capitalize} from "../../utils";


export const Services = () => {
    const [currentPriceItem, setCurrentPriceItem] = React.useState(distributionItems[0]);
    const { t } = useTranslation();
    const els = [
        {
            id: 0,
            el: <Whatsapp className={'servicesIcon'}/>,
            ruPic: '/img/phonescreen/whatsapp_ru.png',
            altText: 'WhatsApp'
        },
        {
            id: 1,
            el: <Telegram className={'servicesIcon'}/>,
            ruPic: '/img/phonescreen/telegram_ru.png',
            altText: 'Telegram'
        },
        {
            id: 2,
            el: <Mail className={'servicesIcon'}/>,
            ruPic: '/img/phonescreen/sms_ru.png',
            altText: 'SMS'
        },
        {
            id: 3,
            el: <Mail className={'servicesIcon'}/>,
            ruPic: '/img/phonescreen/viber_ru.png',
            altText: 'Viber'
        }
    ]

    return (
        <div className={'servicePage'}>
            <div className={'serviceHeader'}>{capitalize(t('pages.features'))}</div>
            <div className={'serviceMainBlock'}>
                <div className={'serviceItems'}>
                    {distributionItems
                        .map((item, index) => <div key={index} className={currentPriceItem.id === item.id ? 'selectedServiceItem' : 'serviceItem'} onClick={() => {setCurrentPriceItem(item)}}>{item[t("prices.titleField")]}</div>)}
                </div>
                <div className={'currentServiceWrapper'}>
                    <div className="glow-circleS"/>
                    <div className="glow-circleM"/>
                    <div className="glow-circle"/>
                    <div className="glow-circleXL"/>
                    <div className={'currentServiceContainer'}>
                        <div className={'servicephonepicturecontainer'}></div>
                        <div className={'servicesInfo'}>
                            <div className={'serviceItemHeaderDesktop'}>{t("services.channelInfo")} {currentPriceItem[t("prices.titleField")]}</div>
                            <div className={'servicesItemsContainer'}>
                                {currentPriceItem[t("services.descField")].map(item => (
                                    <div className="servicesItem" key={item}>
                                        <div className="servicesItemIcon">
                                            <Flash />
                                        </div>
                                        <span className="serviceItemText">{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
